/* Shops & Garages — "Skip the builder, talk to an expert" (Ron, 7 Oct 2026: a simple second
   path on every S&G page for people who don't want to use the configurator).
   Any element with [data-sg-talk] opens the dialog. The form posts to the same WC3 inbound
   webhook as the planner (kind = talk-to-expert), then goes to the thank-you page. */
(function () {
  var app = document.querySelector('.sg-app');
  var dlg = document.getElementById('sgTalk');
  if (!app || !dlg) return;
  var form = dlg.querySelector('form');
  var status = dlg.querySelector('.hl-sg-talk-status');

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sg-talk]');
    if (!t) return;
    e.preventDefault();
    if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    var first = form.querySelector('input[name="full_name"]');
    if (first) first.focus();
  });
  dlg.querySelector('[data-sg-close]').addEventListener('click', function () { dlg.close(); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });

  function ref(seed) {
    var h = 0, s = String(seed || Date.now());
    for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return 'HL-' + h.toString(36).toUpperCase().slice(0, 6);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var d = new FormData(form);
    if (String(d.get('company') || '').trim()) { dlg.close(); return; } // honeypot
    var name = String(d.get('full_name') || '').trim();
    var email = String(d.get('email') || '').trim();
    var phone = String(d.get('phone') || '').trim();
    var webhook = (app.dataset.leadWebhook || '').trim();
    var thankYou = (app.dataset.thankYou || '').trim();
    var reference = ref(email + phone);
    var btn = form.querySelector('button[type="submit"]');

    if (!webhook) { status.textContent = 'This is a demonstration, so nothing was sent anywhere.'; return; }
    btn.disabled = true; status.textContent = 'Sending…';
    var payload = {
      first_name: name.split(/\s+/)[0] || '', last_name: name.split(/\s+/).slice(1).join(' '), full_name: name, name: name,
      email: email, phone: phone, customer_notes: String(d.get('notes') || '').trim(),
      plan_name: 'Talk to an expert', opportunity_name: 'S&G – ' + name + ' – Talk to an expert',
      kind: 'talk-to-expert', lead_source: 'Shops & Garages planner', reference: reference,
      build_summary: 'Shops & Garages – talk to an expert (skipped the 3D builder)\n' +
        (String(d.get('notes') || '').trim() ? 'Customer notes: ' + String(d.get('notes')).trim() + '\n' : '') +
        'Reference: ' + reference,
      store: 'Handley Lumber', page: location.href.split('#')[0], submittedAt: new Date().toISOString()
    };
    var body = JSON.stringify(payload);
    fetch(webhook, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body })
      .then(function (r) { if (!r.ok) throw new Error('webhook ' + r.status); })
      .catch(function (err) {
        if (err && /webhook \d+/.test(err.message)) throw err;
        return fetch(webhook, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'text/plain' }, body: body });
      })
      .then(function () {
        if (thankYou) { location.assign(thankYou + (thankYou.indexOf('?') < 0 ? '?' : '&') + 'ref=' + reference + '&kind=talk'); return; }
        status.textContent = 'Thanks, ' + (name.split(/\s+/)[0] || 'we have it') + '. Our team will be in touch shortly.';
        form.reset();
      })
      .catch(function () {
        status.textContent = 'Could not send just now. Please call the yard at (705) 887-3242.';
      })
      .then(function () { btn.disabled = false; });
  });
})();
